import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class CaptchaService {

    reloadEvents: Subject<void> = new Subject<void>();

    constructor(private http: HttpClient) {

    }

    getCaptcha(isAudioCaptcha: boolean): Observable<Blob> {

        const url = '/api/captcha/';
        let params = {
            'isAudioCaptcha': isAudioCaptcha ? 'true' : 'false'
        };
        return this.http.get(url, {
            params: params,
            responseType: 'blob'
        });
    }

    isValid(captcha: string, email: string): Observable<any> {
        return this.http.post(`/api/captcha/valide/${captcha}?email=${email}`, '', {
            responseType: 'text'
        });
    }

    getImageCaptcha(): Observable<Blob> {

        const url = '/api/captcha/image/';
        /* let options: BaseRequestOptions = new BaseRequestOptions();
        options.responseType = ResponseContentType.Blob; */

        return this.http.get(url, {
            responseType : 'blob'
        });
    }

    reloadCaptcha() {
        this.reloadEvents.next();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/captcha/captcha.service.ts